import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';

import styles from './Title.module.scss';

type HtmlElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type TitleProps = HTMLAttributes<HtmlElement> & {
  className?: string;
  looksLike?: HtmlElement;
  htmlElement: HtmlElement;
  children: React.ReactNode;
};

export const Title: React.FC<TitleProps> = ({ htmlElement, className, looksLike, children, ...props }) =>
  React.createElement(
    htmlElement,
    { className: clsx(styles[looksLike || htmlElement], styles.title, className), ...props },
    children,
  );
